<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Hilfe-Seite für Cop4ALL – NRW</h5>
        <button class="btn btn-outline-secondary" type="button" title="Schließen" aria-label="Close" (click)="modalService.dismissAll()">
          <img src="assets/icons/close.svg" alt="Schließen" width="16" height="16" style="margin-bottom: 4px">
        </button>
    </div>

    <div class="modal-body">
        <h4>Inhalt</h4>

        <ul class="blank">
            <li><a href="#was_ist_cop4all">1. Was ist Cop4ALL NRW?</a></li>
            <li><a href="#wie_funktioniert_cop4all">2. Wie funktioniert Cop4ALL NRW?</a>
                <ul class="blank">
                    <li><a href="#produktauswahl">2.1 Produktauswahl</a></li>
                    <li><a href="#gebietsauswahl">2.2 Gebietsauswahl</a></li>
                    <li><a href="#parametrisierung">2.3 Parametrisierung</a></li>
                    <li><a href="#warenkorb">2.4 Warenkorb</a></li>
                    <li><a href="#uploadportal">2.5 Uploadportal IT-NRW IT-NRW</a></li>
                </ul>
            </li>
        </ul>

        <h4 id="was_ist_cop4all">1. Was ist Cop4ALL NRW?</h4>

        <p>
            Die Landesvermessung in Nordrhein-Westfalen verfolgt seit 2018 das Ziel, Satellitendaten zur
            Aktualisierung der Geobasisdaten des Landes zu nutzen. Für die Umsetzung dieses Vorhabens
            wurde ein zentrales Fernerkundungsverfahren entwickelt, welches die frei verfügbaren
            Sentinel-Daten des Copernicus-Programms (ESA) verwendet:</p>

        <p>
            <b>Cop</b>ernicus <b>für</b>&nbsp;<b>A</b>TKIS, A<b>L</b>KIS und <b>L</b>andbedeckung in <b>NRW</b> -> <b>Cop4ALL
            NRW</b>
        </p>

        <p>
            Bei diesem Zentralen Fernerkundungsverfahren handelt es sich um eine Software, die eine
            <b>Erstableitung der Landbedeckung (LB), Veränderungsinformationen</b> für
            <b>ALKIS</b> und <b>Veränderungsinformationen in der Landbedeckung (LB)</b> auf Grundlage
            der zur Verfügung stehenden Fernerkundungsdaten automatisiert ermitteln soll. Mit der
            Erstellung dieses Verfahrens wurden die Firmen EFTAS und AED-SICAD (VertiGIS) beauftragt.
            Die Software ist zentral bei IT.NRW installiert, so dass <b>Geobasis NRW</b> und alle <b>53
            Katasterbehörden in NRW</b> die Möglichkeit haben, webbasiert auf Cop4ALL NRW zuzugreifen.
        </p>

        <p>
            Die Klassifikation der Landbedeckung erfolgt auf Grundlage einer kombinierten Bildanalyse
            der Sentinel-2-Aufnahmen über einen Zeitraum von einem Jahr sowie den aktuell zur
            Verfügung stehenden Digitalen Orthophotos (DOP). Bei Berechnungen für einen mehr als ein
            Jahr zurückliegenden Zeitraum kann es u.U. angebracht sein, eigene, zu diesem Zeitraum passende,
            DOP hochzuladen. Veränderungshinweise entstehen durch einen Abgleich der berechneten
            Landbedeckung mit dem bestehenden ALKIS- bzw. LB-Datenbestand.
        </p>

        <h4 id="wie_funktioniert_cop4all">2. Wie funktioniert Cop4ALL NRW?</h4>

        <p>
            Der Aufbau von Cop4ALL NRW gleicht einem Bestellsystem, wie man es beispielsweise auch
            aus dem Onlineshopping kennt. Sie werden gleich am Anfang gebeten sich für ein Produkt
            (Erstableitung Landbedeckung, Veränderungsinformationen ALKIS, Veränderungsinformationen
            Landbedeckung oder einer Kombination aus Erstableitung Landbedeckung und einer der
            Veränderungsinformationen) zu entscheiden. Anschließend erfolgt eine Gebietsauswahl sowie
            eine Angabe der für die Berechnung gewünschten Parameter.
            Es können auch eigene Daten über ein Uploadportal hochgeladen werden.
            Ist der Berechnungsauftrag fertiggestellt, kann dieser in den Warenkorb
            abgelegt werden. Falls gewünscht, kann im Anschluss direkt ein neuer Auftrag erstellt werden
            und ebenfalls dem Warenkorb hinzugefügt werden. <em>Hinweis</em>: Sollten innerhalb eines Auftrages
            mehrere Gebiete ausgewählt worden sein (z.B. mehrere Kommunen), so werden die
            Ergebnisse aller in einem Auftrag ausgewählten Gebiete am Ende als eine einzelne Shape-Datei
            ausgegeben! Nachdem alle Aufträge in den Warenkorb übertragen wurden, kann dieser
            abgeschickt werden. Das Absenden des Warenkorbs wird unmittelbar mit einer E-Mail
            bestätigt. Die Bestellbestätigung führt alle versendeten Aufträge innerhalb des Warenkorbs
            noch einmal auf.
        </p>

        <p>
            Nachdem ein Auftrag berechnet wurde, erhalten Sie eine E-Mail mit einem Downloadlink zu
            einer ZIP-Datei, welche die Ergebnisse sowie die Protokolldateien enthält. Im Falle einer
            fehlgeschlagenen Berechnung kann den Protokollen entnommen werden, ob es bei der
            Berechnung zu Fehlern, z.B. durch unvollständige Daten, gekommen ist.
            Innerhalb dieser ZIP-Datei sind die Ergebnisse im Shape-Format (.shp) zu finden.
        </p>

        <h5 id="produktauswahl">2.1 Produktauswahl</h5>

        <p>
            <b>Erstableitung Landbedeckung</b><br>
            Bei dieser Auswahl wird die Landbedeckung für ein ausgewähltes Gebiet berechnet.
        </p>

        <p>
            <b>Erstableitung Landbedeckung + Veränderungsinformation ALKIS</b><br>
            Bei dieser Auswahl wird zunächst die Landbedeckung für das gewählte Gebiet berechnet.
            Darauf basierend werden Veränderungsinformationen gegenüber dem aktuellen oder einem
            ggf. hochgeladenen ALKIS-Datenbestand ermittelt.
        </p>

        <h5 id="gebietsauswahl">2.2 Gebietsauswahl</h5>

        <p>
            Als Nutzer haben Sie hier die Möglichkeit ein Gebiet festzulegen, in welchem das ausgewählte
            Produkt berechnet werden soll. Dabei haben Sie folgende Möglichkeiten:
        </p>

        <p>
            <b>Ein Gebiet in die Karte zeichnen</b><br>
            Hier haben Sie die Möglichkeit, ein Rechteck oder ein Polygon „händisch“ in die Karte
            einzuzeichnen. Das Einzeichnen des Polygons wird mit einem Doppelklick beendet. Die
            eingezeichnete Fläche darf eine Größe von 50 km² nicht unterschreiten. Über die
            Schaltfläche „Geometrie löschen“ wird die Karte wieder bereinigt.
        </p>

        <p>
            <b>Ein oder mehrere Gebiete auswählen</b><br>
            Hier wird Ihnen ermöglicht, auf den Ebenen der Bezirksregierungen, Kreise oder
            Kommunen ein oder mehrere Gebiete auszuwählen. Es ist jedoch zu beachten, dass
            die Ergebnisse aller in der Gebietsauswahl ausgewählten Gebiete/Geometrien, die Teil
            eines Auftrags sind, später in einer einzigen Shape-Datei ausgeliefert werden. Sollten
            Sie für jedes ausgewählte Gebiet getrennte Ergebnis-Shapefiles benötigen, so müssen
            Sie für jedes Gebiet einen einzelnen Auftrag erstellen.
        </p>

        <p>
            <b>Eigene .shp oder .zip Datei hochladen</b><br>
            Die Mindestgröße der georeferenzierten Fläche darf 50 km² nicht unterschreiten.
        </p>

        <h5 id="parametrisierung">2.3 Parametrisierung</h5>

        <p>
            <b>Name des Auftrags</b><br>
            Hier können Sie Ihrem Auftrag einen beliebigen Namen geben.
        </p>

        <p>
            <b>Zeitraum Sentinel-2</b><br>
            Bitte klicken Sie hier auf das Kalender-Symbol rechts im „Ende“-Feld und geben Sie das
            Enddatum des gewünschten Berechnungszeitraums an. Der Zeitraum wird dabei
            automatisch auf ein Jahr ausgeweitet. Innerhalb dieses Jahres werden die aktuellsten
            und geeignetsten Sentinel-2-Aufnahmen für das zuvor von Ihnen definierte Gebiet ausgewählt.
            Darüber hinaus werden automatisch die aktuellen Digitalen Orthophotos
            in die Berechnung einbezogen. Möchten Sie, dass zum gewählten Zeitraum passende
            bzw. eigene Orthophotos verwendet werden, so müssen Sie diese über das
            Uploadportal hochladen (s. Kapitel „Uploadportal IT-NRW“).
            Das älteste auswählbare „Enddatum“ ist der <b>01.04.2019</b>.
        </p>

        <p>
            <b>Automatisches Training</b><br>
            Das automatische Training ist standardmäßig aktiviert. Es lässt sich deaktivierten,
            sobald Sie eigene Trainingsdaten über das Uploadportal zur Verfügung stellen. Sollten
            Sie sich eine Kombination von automatischem Training und eigenen Trainingsdaten
            wünschen, so können Sie die Funktion nach dem Upload der Daten wieder aktivieren.
        </p>

        <p>
            <b>Qualitätsparameter LB</b><br>
            Hierbei handelt es sich um ein Maß für die Zuverlässigkeit/Plausibilität eines jeden
            klassifizierten Polygons. Soll die LB für die Ermittlung von Veränderungsinformationen
            verwendet werden, ist die Aktivierung dieser Funktion zwingend erforderlich. Soll eine
            einfache Landbedeckung berechnet werden, wird diese Zusatzinformation nicht
            benötigt.
        </p>

        <p>
            <b>Optionale Angaben</b><br>
            Bitte geben Sie hier die entsprechenden Upload-IDs an.<br><br>

            <b>Fall 1</b>: Sofern Sie über das Uploadportal verschiedene Datentypen (z.B. DOP und ALKIS
            usw.) <em>gleichzeitig</em> hochgeladen haben, wird Ihnen <em>eine</em> Upload-ID angezeigt. Bitte
            geben Sie diese Upload-ID unter „Optionale Angaben“ für alle von Ihnen
            hochgeladenen Datentypen an.<br>
            <b>Fall 2</b>: Für den Fall, dass Sie verschiedene Datentypen (z.B. DOP und ALKIS)
            <em>nacheinander</em> hochladen, wird Ihnen für jeden Datentyp eine <em>einzelne</em> Upload-ID
            angezeigt. Diese Upload-IDs müssen Sie anschließend unter „Optionale Angaben“ in
            die entsprechenden Felder einfügen.<br><br>

            Sollten Sie Fragen zum Uploadportal selbst oder den Dateiformaten haben, beachten
            Sie bitte die „Hilfe“-Rubrik des Uploadportals!
        </p>

        <h5 id="warenkorb">2.4 Warenkorb</h5>

        <p>
            Nachdem alle Aufträge dem Warenkorb hinzugefügt wurden, kann dieser abgeschickt werden.
            Sie erhalten im Anschluss eine E-Mail-Benachrichtigung mit einer Zusammenfassung der von
            Ihnen erstellten Aufträge inklusive der Angabe der von Ihnen gewählten Berechnungsvariante.
            Für jeden erfolgreich berechneten Auftrag erhalten Sie eine Lieferschein-E-Mail. In dieser
            finden Sie einen Download-Link, über den Sie die Ergebnisse und Protokolle in Form einer
            ZIP-Datei herunterladen können.
        </p>


        <h5 id="uploadportal">2.5 Uploadportal IT-NRW</h5>
        <p>
            <b>Bitte beachten Sie die „Hilfe“ – Rubrik des Uploadportals!</b>
        </p>

        <p>
            Das Uploadportal erreichen Sie in der Cop4ALL NRW - Benutzeroberfläche über den Button
            „Uploadportal IT-NRW“ unten rechts. Dort haben Sie die Möglichkeit folgende Daten aus
            Ihrem eigenen Bestand hochzuladen und über eine bzw. mehrere Upload-IDs (siehe
            „Optionale Angaben“ unter 2.3 Parametrisierung) in Ihre Berechnungen einfließen zu lassen:
        </p>

        <ul>
            <li>DOP</li>
            <li>ALKIS</li>
            <li>nDOM</li>
            <li>Landbedeckung</li>
            <li>Trainingsdaten</li>
            <li>Validierungsdaten</li>
        </ul>

        <p class="text-center"><b>Sollte Sie noch Fragen haben, wenden Sie sich bitte an <a
                href="mailto:cop4all@brk.nrw.de">cop4all&#64;brk.nrw.de</a> !</b></p>

    </div>
</div>
